import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import baseUrl from "../../config/Config";

export const generatePhoneOtp = createAsyncThunk(
  "otp/generatePhoneOtp",
  async ({ phone, member_type = 2 }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
          `${baseUrl}/otp/generatePhoneOtp`,
        {
          phone,
          member_type,
        }, 
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);


export const generatePhoneOtpcompany = createAsyncThunk(
  "otp/generatePhoneOtpcmp",
  async ({ phone, member_type = 2 }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
          `${baseUrl}/otp/login`,
        {
          phone,
          member_type,
        }, 
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

   export const verifyPhoneOtp = createAsyncThunk(
  "otp/verifyPhoneOtp",
  async ({ phone, otp }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "https://onboard.rechargkit.biz/otp/verifyPhoneOtp",
        { phone, otp },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "OTP verification failed"
      );
    }
  }
);


const otpSlice = createSlice({
  name: "otp",
  initialState: {
    loading: false,
    success: false,
    error: null,
    message: null,

    verificationSuccess: false,
    verificationError: null,
  },
  reducers: {
    resetOtpState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.message = null;
      state.verificationSuccess = false;
      state.verificationError = null;
    },
  },

  extraReducers: (builder) => {
    builder

      // 🔹 Send OTP
      .addCase(generatePhoneOtp.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(generatePhoneOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.message = action.payload.message || "OTP sent successfully";
      })
      .addCase(generatePhoneOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to send OTP";
      })

        // 🔹 Send OTPcmp
      .addCase(generatePhoneOtpcompany.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(generatePhoneOtpcompany.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.message = action.payload.message || "OTP sent successfully";
      })
      .addCase(generatePhoneOtpcompany.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to send OTP";
      })
      // 🔹 Verify OTP
      .addCase(verifyPhoneOtp.pending, (state) => {
        state.loading = true;
        state.verificationSuccess = false;
        state.verificationError = null;
      })
      .addCase(verifyPhoneOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.verificationSuccess = true;
        state.message = action.payload.message || "OTP verified successfully";
      })
      .addCase(verifyPhoneOtp.rejected, (state, action) => {
        state.loading = false;
        state.verificationSuccess = false;
        state.verificationError = action.payload || "OTP verification failed";
      });
  },
});

export const { resetOtpState } = otpSlice.actions;
export default otpSlice.reducer;
